<template>
<div id="contenedor-actualizar-catalogo-expediente">
    <v-form ref="actualizarCatalogoExpediente" v-model="esformularioValido">
      <v-card>
        <v-card-title class="secondary--text">
          Actualizar Documento de Catálogo Expediente
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <custom-select
            v-model="expedienteDocumento.idTipoDocumento"
            label="Tipo de Documento"
            :items="getCatalogoTiposDocumentos"
            item-text="descripcion"
            item-value="id">
          </custom-select>
          <custom-text-area
          v-model="expedienteDocumento.descripcion"
          label="Descripción"
          v-on:keyup.enter="mixActualizarCatalogoExpediente"
          >
          </custom-text-area>
          <v-row>
          </v-row>
          <v-row align="center">
            <!-- <custom-select
              cols="3"
              v-model="expedienteDocumento.etapa"
              label="Estapa"
              :items="itemsEtapa"
              item-text="etapa"
              item-value="valor">
            </custom-select> -->
            <custom-text-field
              cols="3"
              v-model.number="expedienteDocumento.orden"
              type="number"
              label="Orden"
              v-on:keyup.enter="mixActualizarCatalogoExpediente"
              >
            </custom-text-field>
            <custom-text-field
            cols="3"
            v-model.number="expedienteDocumento.numeroDocumento"
            type="number"
            label="Numero de Documento"
            v-on:keyup.enter="mixActualizarCatalogoExpediente">
            </custom-text-field>
            <v-switch
              cols="3"
              v-model="expedienteDocumento.seRepite"
              label="¿El documento se repite?"
              inset>
            </v-switch>
          </v-row>
          <v-card-title class="secondary--text">¿En que aplica este documento?</v-card-title>
          <v-row justify="start">
            <v-switch class="mx-4"
              cols="4"
              v-model="expedienteDocumento.esObra"
              label="Obra"
              inset>
            </v-switch>
            <v-switch class="mx-4"
              cols="4"
              v-model="expedienteDocumento.esServicio"
              label="Servicio"
              inset>
            </v-switch>
            <v-switch class="mx-4"
              cols="4"
              v-model="expedienteDocumento.esMinuta"
              label="Minuta"
              inset>
            </v-switch>
            <v-switch class="mx-4"
              cols="4"
              v-model="expedienteDocumento.esLaboratorio"
              label="Laboratorio"
              inset>
            </v-switch>
            <v-switch class="mx-4"
              cols="4"
              v-model="expedienteDocumento.esAutorizacionFp"
              label="Autorización FP"
              inset>
            </v-switch>
            <v-switch class="mx-4"
              cols="4"
              v-model="expedienteDocumento.esJustificacionExcedente"
              label="Justificación Excedente"
              inset>
            </v-switch>
            <v-switch class="mx-4"
              cols="4"
              v-model="expedienteDocumento.esNotaBitacora"
              label="Nota Bitacora"
              inset>
            </v-switch>
          </v-row>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixActualizarCatalogoExpediente"
            :disabled="!esformularioValido || enviandoFormulario"
            tipo="formAceptar"
            label="Actualizar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
</div>
</template>

<script>
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomSelect from '@/components/inputs/Select.vue';
import CustomTextArea from '@/components/inputs/TextArea.vue';
import CustomButton from '@/components/buttons/Button.vue';
import mixCatalogoExpedientes from './mixCatalogoExpedientes';

export default {
  name: 'ActualizarCatalogoExpediente',
  props: {
    expedienteEditar: {
      type: Object,
      required: true,
    },
  },
  mixins: [mixCatalogoExpedientes],
  components: {
    CustomTextField,
    CustomSelect,
    CustomButton,
    CustomTextArea,
  },
  data() {
    return {
      esformularioValido: false,
      enviandoFormulario: false,
      // itemsEtapa: [
      //   { etapa: 'AE', valor: 1 },
      //   { etapa: 'EJ', valor: 2 },
      //   { etapa: 'DE', valor: 3 },
      // ],
      expedienteDocumento: {
        idTipoDocumento: this.expedienteEditar.idTipoDocumento,
        seRepite: this.expedienteEditar.seRepite,
        descripcion: this.expedienteEditar.descripcion,
        // etapa: this.expedienteEditar.etapa,
        orden: this.expedienteEditar.orden,
        numeroDocumento: this.expedienteEditar.numeroDocumento,
        modulo: this.expedienteEditar.modulo,
        esObra: this.expedienteEditar.esObra,
        esServicio: this.expedienteEditar.esServicio,
        esMinuta: this.expedienteEditar.esMinuta,
        esLaboratorio: this.expedienteEditar.esLaboratorio,
        esAutorizacionFp: this.expedienteEditar.esAutorizacionFp,
        esJustificacionExcedente: this.expedienteEditar.esJustificacionExcedente,
        esNotaBitacora: this.expedienteEditar.esNotaBitacora,
      },

    };
  },
  methods: {
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
    limpiarFormulario() {
      this.$refs.actualizarCatalogoExpediente.reset();
    },
  },
};
</script>

<style>

</style>
